/**
 * Idiomas soportados por la web.
 *
 * Módulo puro (sin dependencias) que es la única fuente de verdad de los
 * idiomas: lo consumen los helpers de rutas, la configuración de i18next y el
 * selector de idioma. Se separa de `config.js` para poder testear las rutas
 * sin arrastrar i18next ni los ficheros de traducción.
 */

/** Idioma por defecto. Se sirve SIN prefijo en la URL (compatibilidad con QR y enlaces antiguos). */
export const DEFAULT_LANGUAGE = 'es';

/** Códigos de idioma soportados (el primero es el idioma por defecto). */
export const SUPPORTED_LANGUAGES = ['es', 'en', 'fr', 'pt'];

/** Idiomas que llevan prefijo en la URL (todos menos el de por defecto). */
export const PREFIXED_LANGUAGES = SUPPORTED_LANGUAGES.filter(
  (lang) => lang !== DEFAULT_LANGUAGE
);

/** Nombre de cada idioma en su propia lengua (no se traduce nunca). */
export const LANGUAGE_LABELS = {
  es: 'Español',
  en: 'English',
  fr: 'Français',
  pt: 'Português',
};
